import { error, finish } from '../../../modules/markets/actions/add-dividend';
import api from '../../../api';

export function request(dispatch, { eventId, marketId, dividendType, data }) {
    api.post(`/events/${eventId}/markets/${marketId}/dividends/${dividendType}`, data)
        .then(
            market => {
                market.selections = Object.keys(market.selections).map(x => market.selections[x]);

                dispatch(finish(marketId, market));
            },
            errors => dispatch(error(marketId, errors))
        );
}
